<template>
  <v-form ref="form" v-model="valid">
    <h3 class="title mb-4">Area/Branch Information</h3>
    
    <!-- Area existence check -->
    <v-radio-group
      v-model="areaData.isExisting"
      row
      class="mb-4"
    >
      <template v-slot:label>
        <div class="text-subtitle-1 black--text">
          Does this area already exist in agentPay?
        </div>
      </template>
      <v-radio label="Yes" :value="true"></v-radio>
      <v-radio label="No" :value="false"></v-radio>
    </v-radio-group>
    
    <!-- Existing area dropdown -->
    <div v-if="areaData.isExisting === true" class="mb-4">
      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="areaData.existingArea"
            :items="areas"
            label="Select existing area"
            outlined
            dense
            item-text="text"
            item-value="value"
            return-object
            :rules="[rules.required]"
            required
            @change="handleAreaSelection"
          />
        </v-col>
      </v-row>
      
      <v-card v-if="areaData.existingArea" class="mt-4" outlined>
        <v-card-text>
          <div class="text-subtitle-2 mb-2">Selected Area:</div>
          <div>{{ areaData.existingArea.text }}</div>
          <div class="text-caption">ID: {{ areaData.existingArea.value }}</div>
        </v-card-text>
      </v-card>
    </div>
    
    <!-- New area form -->
    <div v-else-if="areaData.isExisting === false">
      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="areaData.newArea.branchId"
            :items="branches"
            label="Branch"
            outlined
            dense
            item-text="Name"
            item-value="OID"
            :rules="[rules.required]"
            required
          />
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="areaData.newArea.areaName"
            label="Area Name"
            outlined
            dense
            :rules="[rules.required]"
            required
            placeholder="e.g., City Centre, North District"
          />
        </v-col>
      </v-row>
    </div>
    
    <!-- Navigation buttons -->
    <v-row class="mt-6">
      <v-col cols="6">
        <v-btn
          text
          @click="$emit('back')"
        >
          <v-icon left>mdi-arrow-left</v-icon>
          Back
        </v-btn>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          color="primary"
          :disabled="!canProceed"
          @click="proceed"
        >
          Next
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'AreaBranchStep',
  
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    branches: {
      type: Array,
      default: () => []
    },
    areas: {
      type: Array,
      default: () => []
    }
  },
  
  data() {
    return {
      valid: false,
      areaData: this.value,
      rules: {
        required: v => !!v || 'This field is required'
      }
    }
  },
  
  computed: {
    canProceed() {
      if (this.areaData.isExisting === null) {
        return false
      }
      
      if (this.areaData.isExisting) {
        return !!this.areaData.existingArea
      } else {
        return this.valid && 
               this.areaData.newArea.branchId && 
               this.areaData.newArea.areaName
      }
    }
  },
  
  watch: {
    value: {
      deep: true,
      handler(newVal) {
        this.areaData = newVal
      }
    },
    areaData: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      }
    }
  },
  
  methods: {
    
    proceed() {
      if (this.canProceed) {
        this.$emit('next')
      }
    }
  }
}
</script>